import { FormikErrors, FormikProps, useFormik } from 'formik';
import React, { useState } from 'react';
import { Button, Checkbox, Dialog, Grid, Typography } from 'src/components';
import DateTimePicker from 'src/components/DateTimePicker';
import DialogActions from 'src/components/DialogActions';
import DialogContent from 'src/components/DialogContent';
import DialogTitle from 'src/components/DialogTitle';
import Editor from 'src/components/Editor';
import Tab from 'src/components/Tab';
import TabContext from 'src/components/TabContext';
import TabList from 'src/components/TabList';
import TabPanel from 'src/components/TabPanel';
import ParametreGrupEnum from 'src/enums/ParametreGrupEnum';
import { translate } from 'src/i18n/tHelper';
import VwHastauyari1DTO from 'src/models/HastaUyariModels/VwHastauyari1DTO';
import GnlParametreRadioGroup from 'src/parts/Genel/gnl.parametre.radio.group';
import GnlParametreSelect from 'src/parts/Genel/gnl.parametre.select';
import { useHastaUyari1EkleMutation, useHastaUyari1GuncelleMutation } from 'src/services/HastaUyariListesi/HastaUyariListeApi';
import { useAppDispatch, useAppSelector } from 'src/store';
import { HastaUyariSlice } from 'src/store/Slices/HastaUyari/HastaUyariSlice';
import HastaUyari1ModulListesi from './ModulListe';

const translatePath = "pages|hastaUyari";
let formik: FormikProps<VwHastauyari1DTO> = null;
const HastaUyariEkle = (): JSX.Element => {
    const state = useAppSelector(s => s.hastaUyari);
    const dispatch = useAppDispatch();

    const [ekle, ekleState] = useHastaUyari1EkleMutation();
    const [guncelle, guncelleState] = useHastaUyari1GuncelleMutation();

    const handleClose = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        dispatch(HastaUyariSlice.actions.setEkleOpen(false));
    }

    formik = useFormik({
        enableReinitialize: true,
        initialValues: state.activeRow,
        validateOnChange: false,
        onSubmit: (values) => {
            if (values?.id > 0)
                guncelle(values).unwrap().then((v) => {
                    dispatch(HastaUyariSlice.actions.setData({
                        ...state.data,
                        isLoading: true,
                    }));
                    handleClose(null);
                }).catch(e => e);
            else
                ekle(values).unwrap().then((v) => {
                    dispatch(HastaUyariSlice.actions.setData({
                        ...state.data,
                        isLoading: true,
                    }));
                    handleClose(null);
                }).catch(e => e);
        },
        validate: (values) => {
            let errors: FormikErrors<VwHastauyari1DTO> = {};
            if (!values.aciklama || values.aciklama.trim().length === 0)
                errors.aciklama = translate(translatePath, "Açıklama alanı zorunludur.");
            else if (values.aciklama.trim().length < 10)
                errors.aciklama = translate(translatePath, "Açıklama en az 10 karakter olmalıdır.");

            if (!values.uyaritip)
                errors.uyaritip = translate(translatePath, "Uyarı Tipi zorunludur.");

            if (isNaN(new Date(values.uyaribaslangictarih).getTime()))
                errors.uyaribaslangictarih = translate(translatePath, "Geçerli bir başlangıç tarihi giriniz.");
            if (isNaN(new Date(values.uyaribitistarih).getTime()))
                errors.uyaribitistarih = translate(translatePath, "Geçerli bir bitiş tarihi giriniz.");

            if (values.uyaribaslangictarih && values.uyaribitistarih && !isNaN(new Date(values.uyaribaslangictarih).getTime()) && !isNaN(new Date(values.uyaribitistarih).getTime())) {
                const baslangic = new Date(values.uyaribaslangictarih).getTime();
                const bitis = new Date(values.uyaribitistarih).getTime();
                if (bitis < baslangic)
                    errors.uyaribitistarih = translate(translatePath, "Bitiş tarihi, başlangıç tarihinden önce olamaz.");
            }
            if (Object.keys(errors)?.length > 0) {
                const errorMessages = Object.values(errors)?.filter(Boolean).join('\n');
                window.confirm(errorMessages);
            }
            return errors;
        }
    });

    const handleSave = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        if (!ekleState.isLoading && !guncelleState.isLoading)
            formik.submitForm();
    }
    const [tabValue, setTabValue] = useState<string>("1");
    return (
        <Dialog fullWidth open={state.ekleOpen} maxWidth="md" >
            <DialogTitle>{translate(translatePath, "Hasta Uyarı Ekle")}</DialogTitle>
            <DialogContent>
                <Grid container spacing={1}>
                    <Grid item>
                        <TabContext value={tabValue}>
                            <TabList onChange={(e, v) => { setTabValue(v); }}>
                                <Tab label={translate(translatePath, "Uyarı Detayları")} value="1" />
                                <Tab disabled={state.activeRow?.id > 0 ? false : true} label={translate(translatePath, "Modüller")} value="2" />
                            </TabList>
                            {tabValue === "1" && (
                                <TabPanel value="1">
                                    <Grid container>
                                        <Grid item md={3}>
                                            <GnlParametreSelect
                                                parametreType={ParametreGrupEnum.UyariGrubu}
                                                label={translate(translatePath, "Uyarı Grubu")}
                                                name="fkUyaritip"
                                                value={formik.values.fkUyaritip}
                                                onChange={formik.handleChange}
                                            />
                                        </Grid>
                                        <Grid item md={1}>
                                            <Checkbox
                                                label={translate(translatePath, "Tıbbi Uyarı")}
                                                name="tibbiuyari"
                                                checked={formik.values?.tibbiuyari === "E"}
                                                onChange={(e, c) => { formik.setFieldValue("tibbiuyari", c ? "E" : "H") }}
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <DateTimePicker
                                                maxDate={formik.values.uyaribitistarih}
                                                label={translate(translatePath, "Uyarı Başlangıç Tarihi")}
                                                name="uyaribaslangictarih"
                                                value={formik.values.uyaribaslangictarih}
                                                onChange={formik.handleChange}
                                            />
                                        </Grid>
                                        <Grid item md={4}>
                                            <DateTimePicker
                                                minDate={formik.values.uyaribaslangictarih}
                                                label={translate(translatePath, "Uyarı Bitiş Tarihi")}
                                                name="uyaribitistarih"
                                                value={formik.values.uyaribitistarih}
                                                onChange={formik.handleChange}
                                            />
                                        </Grid>
                                        <Grid item md={1.5}>
                                            <Checkbox
                                                label={translate(translatePath, "Uyarı Aktif")}
                                                name="aktif"
                                                checked={formik.values?.aktif === "E"}
                                                onChange={(e, c) => { formik.setFieldValue("aktif", c ? "E" : "H") }}
                                            />
                                        </Grid>
                                        <Grid item md={6}>
                                            <Checkbox
                                                label={translate(translatePath, "Hasta Bütün Müracaatlarında Uyarı Aktif")}
                                                name="hastadosyaaktif"
                                                checked={formik.values?.hastadosyaaktif === "E"}
                                                onChange={(e, c) => { formik.setFieldValue("hastadosyaaktif", c ? "E" : "H") }}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <GnlParametreRadioGroup
                                                parametreType={ParametreGrupEnum.UyariTipi}
                                                name="uyaritip"
                                                value={formik.values.uyaritip}
                                                onChange={formik.handleChange}
                                            />
                                        </Grid>
                                        <Grid item>
                                            <Editor
                                                sx={{ height: "40vh" }}
                                                value={formik.values.aciklama}
                                                onChange={(v) => { formik.setFieldValue("aciklama", v); }}
                                            />
                                        </Grid>
                                    </Grid>
                                </TabPanel>
                            )}
                            {tabValue === "2" && (
                                <TabPanel value="2">
                                    <HastaUyari1ModulListesi />
                                </TabPanel>
                            )}
                        </TabContext>
                    </Grid>
                    <Grid item>
                        <Typography variant="subtitle1" color="primary" sx={{ fontWeight: 600, textAlign: "center", whiteSpace: 'nowrap' }}>
                            {formik.values.adiSoyadi} {translate(translatePath, "Adlı Hasta Uyarısı")}
                        </Typography>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid container justifyContent="flex-end">
                    <Grid item md={4}>
                        <Button customType="save" disabled={!formik.dirty} loading={ekleState.isLoading || guncelleState.isLoading} onClick={handleSave} />
                    </Grid>
                    <Grid item md={4}>
                        <Button customType="close" onClick={handleClose} />
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog >
    );
};

export default HastaUyariEkle;